module.exports = __webpack_public_path__ + "public/img/wait.b305fb32.png";